export var FunnelPropertyType;
(function (FunnelPropertyType) {
    FunnelPropertyType["ApartmentUnitLessThan50M2"] = "APARTMENT_UNIT_LESS_THAN_50M2";
    FunnelPropertyType["ApartmentUnitMoreThan50M2"] = "APARTMENT_UNIT_MORE_THAN_50M2";
    FunnelPropertyType["ServicedApartment"] = "SERVICED_APARTMENT";
    FunnelPropertyType["Studio"] = "STUDIO";
    FunnelPropertyType["StudentAccommodation"] = "STUDENT_ACCOMMODATION";
    FunnelPropertyType["WarehouseApartment"] = "WAREHOUSE_APARTMENT";
    FunnelPropertyType["Duplex"] = "DUPLEX";
    FunnelPropertyType["Villa"] = "VILLA";
    FunnelPropertyType["FullyDetachedHouse"] = "FULLY_DETACHED_HOUSE";
    FunnelPropertyType["KitHome"] = "KIT_HOME";
    FunnelPropertyType["MultiDwellingSingleTitle"] = "MULTI_DWELLING_SINGLE_TITLE";
    FunnelPropertyType["PropertyOver10HA"] = "PROPERTY_OVER_10_HA";
    FunnelPropertyType["SemiDetachedHouse"] = "SEMI_DETACHED_HOUSE";
    FunnelPropertyType["Terrace"] = "TERRACE";
    FunnelPropertyType["Townhouse"] = "TOWNHOUSE";
    FunnelPropertyType["Land"] = "LAND";
})(FunnelPropertyType || (FunnelPropertyType = {}));
//# sourceMappingURL=index.js.map